import { useNavigation } from 'modules/core/hooks/useNavigation'

export function useSyncIssueUrls({
  datoId,
  companyId,
}: {
  datoId: string | undefined | null
  companyId?: string
}): { employeesUrl: string; integrationSettingsUrl?: string } {
  const { navigation } = useNavigation()

  const switchParam = companyId ? `?switchToCompanyId=${companyId}` : ''

  const employeesUrl = `${navigation.employees.fullPath()}${switchParam}`

  const integrationSettingsUrl = datoId
    ? `${navigation.discover.marketplace.item.settings.fullPath({
        id: datoId,
      })}${switchParam}`
    : undefined

  return { employeesUrl, integrationSettingsUrl }
}
